import classes from "./ActionCompetenceBadge.module.css";
import {IoPieChartOutline} from "react-icons/io5";

type props = {
  competenceName: string
}

export default function ActionCompetenceBadge({competenceName}: props) {
  return (
    <div className={classes.ActionCompetenceBadge}>
      <IoPieChartOutline/>
      <span>{ competenceName }</span>
    </div>
  )
}
